import React from 'react';
import { Link } from 'react-router-dom';

import '../../../css/shared/btn.scss';
export function Btn(props) {
  if (props.to || props.href) {
    if(props.target) {
      return (
        <Link className={ `link Btn ${ props.className ? props.className : '' }` } onClick={ props.onClick } to={ props.to || props.href } target={ props.target }>
          { props.children }
        </Link>
      )
    } 
    return (
      <Link className={ `link Btn ${ props.className ? props.className : '' }` } onClick={ props.onClick } to={ props.to || props.href }>
        { props.children }
      </Link>
    )
  }
  return (
    <div className={ `Btn ${ props.className ? props.className : '' }` } onClick={ props.onClick }>
      { props.children }
    </div>
  )
}